/**
 * Created by JIocb on 22.06.2017.
 */

module Factive.Core {
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    import Armature = dragonBones.Armature;
    import DragonBonesButton = Factive.Game.DragonBonesButton;
    import EventBusConstants = Factive.Core.EventBusConstants;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;

    export class AreYouSurePanel extends Panel {

        private _yesBtn:DragonBonesButton;
        private _noBtn:DragonBonesButton;
        private _text:PIXI.Text;
        private _lm:LocalizationManager;
        private _armature: dragonBones.Armature;
        private _message:PIXI.Text;

        constructor(dc: DependenciesContainer,name:any) {
            "use strict";
            super(dc,name);
            this._lm = this._dc.get("LocalizationManager");
        };

        protected build() {
            "use strict";
            this._armature = dragonBones.PixiFactory.factory.buildArmature("Panel_BaseDialog");
            this.addChild(<PIXI.DisplayObject>this._armature.display);
            dragonBones.WorldClock.clock.add(this._armature);
            this._armature.animation.play("appear",1);

            this._yesBtn = new DragonBonesButton(this._armature.getSlot("PopupRedBtn").childArmature,this._dc);
            this._noBtn = new DragonBonesButton(this._armature.getSlot("PopupBlueBtn").childArmature,this._dc);

            this._yesBtn.addLabel(this._lm.getText("yes"), 0, 0, <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: 20* this._assetScale,
                fill: '#FFFFFF',
                align: "center"
            });

            this._noBtn.addLabel(this._lm.getText("no"), 0, 0, <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: 20* this._assetScale,
                fill: '#FFFFFF',
                align: "center"
            });

            this._yesBtn.addPressListener(this.handlePressYes,this);
            this._noBtn.addPressListener(this.handlePressNo,this);

            this._message = new PIXI.Text(this._lm.getText("are_you_sure_quit"),<PIXI.TextStyle>{
                fontFamily:'Medium',
                fontSize:46* this._assetScale,
                fill:'#1B4F5A',
                align:"center"
            });

            this._message.anchor.set(.5,.5);
            this._armature.getSlot("text_container").display = this._message;
        };


        private handlePressYes(evt):void
        {
            this._yesBtn.removePressListener(this.handlePressYes,this)
            this._noBtn.removePressListener(this.handlePressNo,this)
            this.sendEvent(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI, this._data);
        }

        private handlePressNo(evt):void
        {
            this._yesBtn.removePressListener(this.handlePressYes,this)
            this._noBtn.removePressListener(this.handlePressNo,this)

            this.sendEvent(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI, this._data);

        }

        public reset():void
        {
            if(this._armature)
            {
                this._yesBtn.removePressListener(this.handlePressYes,this)
                this._noBtn.removePressListener(this.handlePressNo,this)

                this._yesBtn.destroy();
                this._noBtn.destroy();

                this._yesBtn = null;
                this._noBtn = null;

                this.removeChild(<PIXI.DisplayObject>this._armature.display);
                dragonBones.WorldClock.clock.remove(this._armature);
                this._armature = null;
            }
            super.reset();
        };

        public destroy():void
        {
            this._yesBtn.removePressListener(this.handlePressYes,this)
            this._noBtn.removePressListener(this.handlePressNo,this)

            this._yesBtn.destroy();
            this._noBtn.destroy();

            this._yesBtn = null;
            this._noBtn = null;

            this._lm = null;

            this.removeChild(this._message);
            this._message = null;

            super.destroy();

        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/AreYouSurePanel.ts